export default __webpack_public_path__ + "static/media/audio4_arm.1fb61602.m4a";